import React, { useMemo, useState, useCallback } from 'react';
import { PanelHeader } from 'js/components';
import { Route, Switch } from 'react-router-dom';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { useParams, useRouteMatch } from 'react-router-dom';
import ConfirmModal from 'js/components/modal/ConfirmModal';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import { Icon } from 'js/components';
import { faBoxArchive, faBoxOpen } from '@fortawesome/pro-regular-svg-icons';
// import ProductManagerCapabilities from './ProductManagerCapabilities';
import ProductManagerUserGroups from './ProductManagerUserGroups';

// import styles from './ProductManagersDashboard.module.scss';

// const TABS = {
//   USER_GROUPS: 'user-groups',
//   CAPABILITIES: 'capabilities',
//   SETTINGS: 'settings',
// };

// function getActiveTab() {
//   if (
//     null !=
//     matchPath(window.location.pathname, {
//       path: '/w/:workspaceId/pm/product-managers/:productManagerId/settings',
//     })
//   ) {
//     return TABS.SETTINGS;
//   } else if (
//     null !=
//     matchPath(window.location.pathname, {
//       path: '/w/:workspaceId/pm/product-managers/:productManagerId/capabilities',
//     })
//   ) {
//     return TABS.CAPABILITIES;
//   } else {
//     return TABS.USER_GROUPS;
//   }
// }

function ProductManagersDashboard({
  hasLoaded,
  // isLoading,
  productManager,
  onUpdate,
}) {
  const { workspaceId } = useParams();
  const match = useRouteMatch();

  // const matchedTab = useMemo(getActiveTab, [window.location.pathname]);

  const breadcrumbs = useMemo(
    () => [
      {
        label: 'Product managers',
        to: `/w/${workspaceId}/pm/product-managers`,
      },
    ],
    [workspaceId]
  );

  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const handleArchive = () => {
    setShowArchiveModal(true);
  };

  const handleRestore = useCallback(() => {
    return onUpdate({ id: productManager.id, archived_state: null });
  }, [productManager?.id, onUpdate]);

  const handleArchiveModalConfirm = useCallback(async () => {
    await onUpdate({
      id: productManager.id,
      archived_state: 'archived',
    });
    setShowArchiveModal(false);
  }, [productManager?.id, onUpdate]);

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="content-fluid">
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center">
                <h1>{productManager?.name}</h1>
              </div>
              <div className="d-flex align-items-center">
                <div className="actions">
                  <UncontrolledDropdown disabled={!productManager}>
                    <DropdownToggle color="primary" caret>
                      Actions
                    </DropdownToggle>
                    <DropdownMenu right>
                      {productManager?.archived_state == null ? (
                        <DropdownItem onClick={handleArchive}>
                          <Icon
                            icon={faBoxArchive}
                            size="lg"
                            className="btn-icon-left"
                            fixedWidth
                          />
                          Archive
                        </DropdownItem>
                      ) : (
                        <DropdownItem onClick={handleRestore}>
                          <Icon
                            icon={faBoxOpen}
                            size="lg"
                            className="btn-icon-left"
                            fixedWidth
                          />
                          Restore
                        </DropdownItem>
                      )}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
          {productManager?.archived_state === 'archived' && (
            <div className="badge badge-warning">Archived</div>
          )}
        </div>
        {/* <div className="container-fluid">
          <Nav className="tab-nav nav-underline">
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                active={matchedTab === TABS.USER_GROUPS}
                data-view="active"
                to={`/w/${workspaceId}/pm/product-managers/${productManagerId}`}
              >
                User groups
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                data-view="results"
                to={`/w/${workspaceId}/pm/product-managers/${productManagerId}/capabilities`}
                active={matchedTab === TABS.CAPABILITIES}
              >
                Capabilities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                data-view="results"
                to={`/w/${workspaceId}/pm/product-managers/${productManagerId}/settings`}
                active={matchedTab === TABS.SETTINGS}
              >
                Settings
              </NavLink>
            </NavItem>
          </Nav>
        </div> */}
      </PanelHeader>
      <div className="content" style={{ position: 'relative' }}>
        {hasLoaded && (
          <Switch>
            {/* <Route path={`${match.url}/capabilities`}>
              <ProductManagerCapabilities productManager={productManager} />
            </Route> */}
            <Route path={`${match.path}`}>
              <ProductManagerUserGroups productManager={productManager} />
            </Route>
          </Switch>
        )}
      </div>
      <ConfirmModal
        isOpen={showArchiveModal}
        title="Archive product manager?"
        onConfirm={handleArchiveModalConfirm}
        onCancel={() => setShowArchiveModal(false)}
        confirmButtonLabel="Archive"
      >
        <p>
          Please confirm that you want to archive{' '}
          <strong>{productManager?.name || 'this product manager'}</strong>.
        </p>
      </ConfirmModal>
    </div>
  );
}

export default ProductManagersDashboard;
